<template>
    <Paper class="gis-site-correction">
        <el-input placeholder="请输入地址" prefix-icon="el-icon-search" v-model.trim="site" clearable
            class="gis-site-address">
        </el-input>
        <el-button type="primary" @click="setSite" class="gis-site-button">定位</el-button>
        <el-button type="primary" @click="() => (queryVisible = true)" class="gis-site-button">纠错查询</el-button>
        <div class="gis-site-area">
            <el-checkbox v-model="checked" @change="isCheckedChang">是否显示区域</el-checkbox>
            <otpAllAddressSelect class="gis-site-area-select" :minLayers="3" :areaUrl="areaUrl" v-model="addressSite"
                @getAddress="getAddressSite" v-show="true"></otpAllAddressSelect>
        </div>
        <el-row class="gis-site-parse">
            <otpAllAddressSelect class="address-content" :minLayers="4" :areaUrl="areaUrl" v-model="address"
                @getAddress="getAddress" :disabled="true" ref="city"></otpAllAddressSelect>
            <el-input class="gis-site-point" placeholder="longitude,latitude" v-model.trim="mapConfig.position">
                <template slot="prepend">当前坐标</template>
            </el-input>
            <el-button class="gis-site-parse-button" type="primary" @click="updateCity"
                :loading="updateLoading">解析定位</el-button>
            <div class="gis-site-save-button">
                <el-button type="primary" @click="save" :disabled="closeState" :loading="loadingState">保存</el-button>
            </div>
        </el-row>
        <div class="map-wrapper">
            <m-map class="gis-site-map" ref="map" :config="mapConfig" @ready="handleReady" @moveend="moveend"
                @zoomend="zoomend">
                <div v-show="showPolygon">
                    <bm-polygon v-for="(path, index) of polygonObjs" :path="path.Polygon.coordinate"
                        :key="'gon' + index" :fillColor="path.Polygon.fillColor" :stroke-opacity="0.6"
                        :stroke-weight="2" strokeStyle="dashed" :massClear="true" :fillOpacity="0.1">
                    </bm-polygon>
                </div>
            </m-map>
            <img src="./site.png" class="mapicon">
        </div>
        <el-dialog title="纠错记录查询" :close-on-click-modal="false" v-if="queryVisible" :visible.sync="queryVisible" width="1200px">
            <QueryRecord></QueryRecord>
        </el-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import otpAllAddressSelect from '@/components/lots/otpCascader2';
import MMap from '@/components/gis/siteCorrection/mMap';
import QueryRecord from './dialog/QueryRecord';
import { addSiteApi, correctionOrderApi, gisPolygonApi, getGisInfoApi } from './api';
const ADDRESS_STRING_LENGTH = 90;// 地址长度
export default {
    name: 'baseInfo',
    components: {
        Paper,
        MMap,
        otpAllAddressSelect,
        QueryRecord
    },
    props: {
        errorAddress: {
            type: String,
            default() {
                return '';
            }
        },
        fromAbnormityManage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            queryVisible: false,
            site: '',
            addressSite: '',
            dragState: true,
            closeState: false,
            point: {
                lat: null,
                lng: null
            },
            address: [],
            orderNo: '',
            inOutType: '',
            customerAddress: {},
            mapConfig: {
                center: '',
                zoom: 15,
                target: {},
                position: '',
                currentPointInfo: {
                    surroundingPois: [{ title: '' }]
                }
            },
            keywork: '',
            keyworkList: [],
            addressList: {},
            map: null,
            BMap: null,
            checked: false,
            showPolygon: false,
            polygonObjs: [],
            loadingState: false,
            updateLoading: false,
            receiverCityName: '', // otp-订单中心-传入市
            receiverProvinceName: '', // otp-订单中心-传入省
            addressType: '', // opt-订单中心-传入地址类型
            saveInterval: false, // 保存按钮间隔
            pointInterval: false, // 解析定位按钮间隔
            areaUrl: '/anapi-oms/searchagg/gis/searchEbPlace' // 地址获取接口
        };
    },
    methods: {
        handleReady({ BMap, map }) {
            const _this = this;
            this.BMap = BMap;
            this.map = map;
            if (this.site) {
                this.setSite();
            } else {
                const geolocation = new BMap.Geolocation();
                geolocation.getCurrentPosition(function (r) {
                    map.centerAndZoom(new BMap.Point(r.longitude, r.latitude), 15);
                    if (this.getStatus() === 0) {
                        _this.mapConfig.position = ``;
                    }
                }, { enableHighAccuracy: true });
            }
        },
        /**
         * 地址格式校验（不能为空，最少7位中文，总长度不超过90）
         * @param regWord 中文校验（至少7位中文）
         */
        siteVerify() {
            let siteCheck = false;
            const regWord = /(?=([\u4e00-\u9fa5].*){7,})/g;// 最少7个字中文校验
            if (!this.site || !regWord.test(this.site) || this.site.length > ADDRESS_STRING_LENGTH) {
                this.$message.warning('地址不规范，需包含至少7个中文字且长度不超过90个字');
                siteCheck = true;
            }
            return siteCheck;
        },
        async setSite() {
            const siteResult = this.siteVerify();
            if (siteResult) { return; }
            this.mapConfig.position = '';
            const localResult = await this.$refs.map.analysisLocal(this.site.slice(0, 3), this.site);
            this.point = localResult || { lat: '', lng: '' };
            if (!localResult) {
                this.$message.warning('地址解析错误，请手动拖拽标准至准确的位置');
                return;
            }
            this.mapConfig.position = `${this.point.lng},${this.point.lat}`;
            this.$set(this.mapConfig, 'center', {
                lng: this.point.lng, lat: this.point.lat
            });
            this.map.centerAndZoom(this.point, 15);
            const addressResult = await gisPolygonApi({ region: `${this.point.lng} ${this.point.lat}` });
            if (!addressResult) return;
            this.address = this.initAddress(addressResult.data[0].code);
            await this.$refs.city.init(this.address);
            const jugeCityList = this.$refs.city.addressFormat(this.address);
            if (!jugeCityList[3]) {
                this.$message.warning('四级已停用');
            }
        },
        async save() {
            const siteResult = this.siteVerify();
            if (siteResult) { return; }
            if (this.address.length !== 4) {
                this.$message.warning(`请补全四级地址`);
                return;
            }
            if (((+this.point.lng) !== (+this.mapCenter.lng) && (+this.point.lat) !== (+this.mapCenter.lat))) {
                this.$message.warning(`坐标地址已改变,请重新获取四级地址`);
                return;
            }
            this.addressCn = this.$refs.city.addressFormat(this.address);
            if (!this.address[3] || !this.addressCn[3]) {
                this.$message.warning(`当前纠错地址无四级区域，无法保存`);
                return;
            }
            if (this.saveInterval) {
                this.$message.warning(`多次点击按钮间隔必须大于3秒`);
                return;
            }
            this.saveInterval = true;
            setTimeout(() => {
                this.saveInterval = false;
            }, 3000);
            this.loadingState = true;
            if (this.receiverProvinceName && this.receiverCityName) {
                const provinceDis = this.receiverProvinceName.substring(0, 2) !== this.addressCn[0].substring(0, 2);
                const cityDis = this.receiverCityName.substring(0, 2) !== this.addressCn[1].substring(0, 2);
                if (provinceDis || cityDis) {
                    this.$confirm('当前地址与解析出的地址省、市不匹配，是否继续保存?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.saveNext();
                    }).catch(() => {
                        this.loadingState = false;
                    });
                } else {
                    this.saveNext();
                }
            } else {
                this.saveNext();
            }
        },
        async saveNext() {
            const params = {
                lng: this.point.lng,
                lat: this.point.lat,
                keyWork: this.keyworkList.join(','),
                province: this.addressCn[0],
                city: this.addressCn[1],
                area: this.addressCn[2],
                country: this.addressCn[3],
                provinceCode: this.address[0],
                cityCode: this.address[1],
                areaCode: this.address[2],
                countryCode: this.address[3],
                address: this.site
            };
            // 走完gis请求再走纠错接口
            const result = await addSiteApi(params);
            if (result) {
                this.$message({
                    type: 'success',
                    message: '保存成功'
                });
            };
            this.loadingState = false;
            if (this.orderNo) {
                const param = {
                    orderNo: this.orderNo,
                    lng: this.point.lng,
                    lat: this.point.lat
                };
                if (this.addressType) param[this.addressType] = this.address[this.address.length - 1];
                this.$confirm('工程师已经尽力校对了，可能存在偏差，请仔细核对?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    correctionOrderApi(param).then(res => {
                        if (res) {
                            this.$message.success('纠正成功');
                            this.$eventBus.$emit('closeTag', this.$route);
                            this.$router.push({ path: '/order-manage/order-center' });
                        }
                        this.loadingState = false;
                    });
                });
            }
        },
        isCheckedChang(val) {
            this.polygonObjs = [];
            this.map.clearOverlays();
            if (!val) return;
            if (this.addressSite.length !== 3) return;
            this.getPolygonList(val);
        },
        getSiteData(val) {
            this.addressList = Object.assign({}, val);
        },
        addKeywork() {
            if (this.keywork && this.keyworkList.length < 3) {
                this.keyworkList.push(this.keywork);
            } else {
                const msg = this.keywork ? (this.keyworkList.length >= 3 ? '关键词已超出限制' : '') : '关键词为空';
                this.$message.warning(`${msg}`);
            }
            this.keywork = '';
        },
        delKeywork(index) {
            this.keyworkList.splice(index, 1);
        },
        moveend({ type, target }) {
            this.mapCenter = this.$refs.map.map.getCenter();
            this.mapConfig.position = this.mapCenter.lng + ',' + this.mapCenter.lat;
        },
        zoomend({ type, target }) {
            // this.mapCenter = this.$refs.map.map.getCenter();
            // this.mapConfig.position = this.mapCenter.lng + ',' + this.mapCenter.lat;
        },
        updateCity() {
            this.updateLoading = true;
            this.mapConfig.position = this.mapConfig.position.replace(/，|\ +/g, ',');
            if (this.mapConfig.position.split(',').length !== 2) {
                this.$message.warning(`请输入正确的坐标格式：lng,lat`);
                this.updateLoading = false;
                return;
            }
            if (this.pointInterval) {
                this.$message.warning(`多次点击按钮间隔必须大于3秒`);
                this.updateLoading = false;
                return;
            }
            this.pointInterval = true;
            setTimeout(() => {
                this.pointInterval = false;
            }, 3000);
            try {
                const [lng, lat] = this.mapConfig.position.split(',');
                this.point.lat = lat;
                this.point.lng = lng;
                this.$set(this.mapConfig, 'center', { lng, lat });
                const point = new this.BMap.Point(lng, lat);
                this.map.centerAndZoom(point, 15);
                gisPolygonApi({ region: `${lng} ${lat}` }).then(async (res) => {
                    this.updateLoading = false;
                    this.address = [];
                    if (!res) return;
                    if (!res.data[0].code) {
                        this.$message.warning(`四级地址解析失败`);
                    };
                    this.address = this.initAddress(res.data[0].code);
                    await this.$refs.city.init(this.address);
                    const jugeCityList = this.$refs.city.addressFormat(this.address);
                    if (!jugeCityList[3]) {
                        this.$message.warning('四级已停用');
                    }
                });
            } catch (error) {
                this.$message.warning(`当前坐标异常,请输入正确的坐标`);
                this.updateLoading = false;
            }
        },
        getAddress(val) {
            this.addressCn = val;
        },
        getAddressSite(val) {
            this.polygonObjs = [];
            this.map.clearOverlays();
            this.getPolygonList(this.checked);
        },
        initAddress(start) {
            const arr = [];
            arr[0] = start.slice(0, 3);
            arr[1] = start.slice(3, 5);
            arr[2] = start.slice(5, 7);
            arr[3] = start.slice(7, 10);
            arr.forEach((item, index) => {
                if (!item) {
                    arr.length = index;
                } else {
                    if (index > 0) {
                        arr[index] = arr[index - 1] + item;
                    }
                }
            });
            return arr;
        },
        coorList(list) {
            return list.map((el, i) => {
                const centerPoint = {
                    lng: el.centerPoint ? el.centerPoint.split(' ')[0] : null,
                    lat: el.centerPoint ? el.centerPoint.split(' ')[1] : null
                };
                const opts = {
                    position: centerPoint, // 指定文本标注所在的地理位置
                    offset: new this.BMap.Size(0, 0) // 设置文本偏移量
                };
                const label = new this.BMap.Label(el.name, opts);
                label.setStyle(this.labelstyleconfig);
                this.map.addOverlay(label);
                return {
                    label: label,
                    center: centerPoint,
                    content: el.name,
                    code: el.code,
                    version: el.version,
                    Polygon: {
                        coordinate: el.list,
                        fillColor: 'blue',
                        editing: false
                    },
                    id: el.id,
                    type: el.type,
                    source: el.source
                };
            });
        },
        getPolygonList(bool) {
            if (!bool) return;
            if (this.addressSite.length === 0) return;
            const params = {};
            params['provinceCode'] = this.addressSite[0] ? this.addressSite[0] : null;
            params['cityCode'] = this.addressSite[1] ? this.addressSite[1] : null;
            params['areaCode'] = this.addressSite[2] ? this.addressSite[2] : null;
            params['type'] = 'country';
            getGisInfoApi(params).then(res => {
                if (!res) return;
                this.showPolygon = true;
                this.polygonObjs = this.coorList(res.data.list);
            });
        }
    },
    activated() {
        if (this.$route.params.address) {
            this.site = this.$route.params.address;
            this.orderNo = this.$route.params.orderNo;
            this.inOutType = this.$route.params.inOutType;
            this.receiverCityName = this.$route.params.receiverCityName;
            this.receiverProvinceName = this.$route.params.receiverProvinceName;
            this.addressType = this.$route.params.addressType;
        }
    },
    watch: {
        site: {
            handler(val) {
                this.closeState = !(val && val !== '');
            }
        },
        fromAbnormityManage: {
            handler(val) {
                val && (this.site = this.errorAddress);
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style lang="less">
.gis-site-correction {
    .gis-site-address {
        width: 40%;
        margin-right: 10px;
    }

    .gis-site-button {
        margin-left: 10px;
    }

    .gis-site-area {
        float: right;
        display: flex;
        align-items: center;
    }

    .gis-site-area-select {
        display: inline-block;
        width: 60%;
    }

    .gis-site-parse {
        margin-top: 10px;
    }

    .address-content {
        width: 40%;
        float: left;
        margin-right: 10px;

        .el-input.is-disabled .el-input__inner {
            color: #898C8C;
        }
    }

    .gis-site-point {
        width: 20%;
        float: left;
    }

    .gis-site-parse-button {
        float: left;
        margin-left: 10px;
    }

    .gis-site-save-button {
        float: right;
    }

    .gis-site-map {
        height: 100%;
    }

    .el-cascader {
        width: 100%;
    }

    .map-wrapper {
        position: relative;
        margin: 10px 0;
        height: calc(100vh - 150px);

        .mapicon {
            position: absolute;
            top: 45.5%;
            width: 30px;
            left: 49%;
        }
    }
}
</style>
